import type { PZItem } from '../../types/pz';

/**
 * Is this PZ line locked because it traces back to a supplier order?
 *
 * A traced line's physical product and quantity are fixed: the supplier order
 * decided them, and the backend refuses a save that changes either
 * (`PZ_SUPPLIER_ORDER_TRACE_LOCKED`). The UI has to know that BEFORE the
 * operator edits, not after the save is rejected.
 *
 * Single home because the answer must be identical for every control the lock
 * governs — the product picker, the physical-quantity input and the
 * unit-conversion modal's lock notice — and because the field it reads is easy
 * to get wrong: `sourceSupplierOrderItemId` LOOKS like the right signal, but
 * `responseFilter` strips it from every PZ response, so gating on it silently
 * disables nothing. That is exactly the gap live QA found: a ZD-traced draft
 * line offered an enabled picker and an editable quantity, and only the
 * backend 400 stopped it.
 *
 * The remove button is deliberately NOT governed by this lock: an operator may
 * remove a traced line wholesale from an editable PZ ("wybór pozycji przy
 * przyjęciu częściowym") — coverage is quantity-based off persisted PZItem
 * rows, so removal simply frees that ZD line's quantity for a later PZ.
 */
export function isPZItemTraceLocked(
  item: Pick<PZItem, 'supplierOrderTraceLocked'>,
): boolean {
  return item.supplierOrderTraceLocked === true;
}
